export class BIM360Company
{
    public id: string = '';
    public name: string = '';
    public accountId: string = '';
    public memberGroupId: string = '';

    public static fromAutodeskJSON(json: any): BIM360Company
    {
        let company = new BIM360Company();
        company.id = json.id;
        company.name = json.name;
        company.accountId = json.account_id;
        company.memberGroupId = json.member_group_id;

        return company;
    }
}
